import organizations from './organizations';

export default {
  organizations,
};
